export default __webpack_public_path__ + "static/media/wealth.c9ec902c.jpg";